'use client';

import React from 'react';
import Empty from '../../../../public/images/empty/empty.svg';
import Error from '../../../../public/images/empty/error.svg';
import Icon, { IconName } from './Icon';
import { cn } from '@/app/lib/utils';

const ICONS: Record<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
  empty: Empty,
  error: Error,
};

interface StatusCardProps {
  type: 'empty' | 'error';
  heading: string;
  headingClassName?: string;
  text?: string;
  iconSize?: number;
  actionLabel?: string;
  actionClassName?: string;
  iconWrapperClassname?: string;
  actionIcon?: IconName;
  onAction?: () => void;
  className?: string;
}

const StatusCard: React.FC<StatusCardProps> = ({
  type,
  heading,
  headingClassName,
  text,
  iconSize = 88,
  actionLabel,
  actionClassName = '',
  iconWrapperClassname,
  actionIcon,
  onAction,
  className = '',
}) => {
  return (
    <div
      className={cn(
        'w-full flex flex-col items-center justify-center py-16 px-4 rounded-2xl min-h-[320px]',
        className
      )}
    >
      <div className={cn('mb-4', iconWrapperClassname)}>
        {ICONS[type] && (
          <span className="block" style={{ width: iconSize, height: iconSize }}>
            {React.createElement(ICONS[type], {
              width: iconSize,
              height: iconSize,
              'aria-label': type,
              role: 'img',
              style: { display: 'block', margin: '0 auto' },
            })}
          </span>
        )}
      </div>
      <h2 className={cn('text-sm font-medium text-center text-foreground', headingClassName)}>
        {heading}
      </h2>
      {text && <p className="text-center text-xs text-muted-foreground max-w-xl">{text}</p>}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className={cn(
            `w-[244px] mt-2 px-[10px] py-[10px] rounded-lg chat-btn-alternate text-white font-semibold cursor-pointer`,
            actionClassName
          )}
        >
          {actionIcon && <Icon name={actionIcon} size={5} />}
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default StatusCard;
